//域名
const domain = window.location.host + "/api";
//const domain = window.location.host;

//端口
const port = null;

const path = "";


//路径
const root = window.location.protocol + "//" + domain + (port ? (":" + port) : "") + path;

//接口
const api = {
    user: {
        list: `${root}/user/list`,
        add: `${root}/user/add`,
        update: `${root}/user/update`,
        detail: `${root}/user/detail`,
        delete: `${root}/user/delete`,
        batchDelete: `${root}/user/batchDelete`,
    },
    dictType: {
        list: `${root}/dictType/list`,
        add: `${root}/dictType/add`,
        update: `${root}/dictType/update`,
        detail: `${root}/dictType/detail`,
        delete: `${root}/dictType/delete`,
        batchDelete: `${root}/dictType/batchDelete`,
        allDict: `${root}/dictType/allDict`,
        exportDict: `${root}/dictType/exportDict`,
        importDict: `${root}/dictType/importDict`,
    },
    menu: {
        list: `${root}/menu/list`,
        add: `${root}/menu/add`,
        update: `${root}/menu/update`,
        detail: `${root}/menu/detail`,
        delete: `${root}/menu/delete`,
        batchDelete: `${root}/menu/batchDelete`,
        exportMenu: `${root}/menu/exportMenu`,
        importMenu: `${root}/menu/importMenu`,
        tree: `${root}/menu/tree`,
    },
    area: {
        list: `${root}/area/list`,
        add: `${root}/area/add`,
        update: `${root}/area/update`,
        detail: `${root}/area/detail`,
        delete: `${root}/area/delete`,
        batchDelete: `${root}/area/batchDelete`,
        tree: `${root}/area/tree`,

    },
    module: {
        list: `${root}/module/list`,
        add: `${root}/module/add`,
        update: `${root}/module/update`,
        detail: `${root}/module/detail`,
        delete: `${root}/module/delete`,
        batchDelete: `${root}/module/batchDelete`,
        tree: `${root}/module/tree`,
    },
    role: {
        list: `${root}/role/list`,
        add: `${root}/role/add`,
        update: `${root}/role/update`,
        detail: `${root}/role/detail`,
        delete: `${root}/role/delete`,
        batchDelete: `${root}/role/batchDelete`,
    },
    rule: {
        list: `${root}/rule/list`,
        add: `${root}/rule/add`,
        update: `${root}/rule/update`,
        detail: `${root}/rule/detail`,
        delete: `${root}/rule/delete`,
        batchDelete: `${root}/rule/batchDelete`,
        sync: `${root}/rule/sync`,
    },
    action: {
        list: `${root}/action/list`,
        add: `${root}/action/add`,
        update: `${root}/action/update`,
        detail: `${root}/action/detail`,
        delete: `${root}/action/delete`,
        batchDelete: `${root}/action/batchDelete`,
    },
    auth: {
        login: `${root}/auth/login`,
        logout: `${root}/auth/logout`,
        userInfo: `${root}/auth/userInfo`,
        updateUserPassword: `${root}/auth/updateUserPassword`,
        verifyCode: `${root}/auth/verifyCode`,
        updateUserInfo: `${root}/auth/updateUserInfo`,
        menuTree: `${root}/auth/menuTree`,
    },
    department: {
        list: `${root}/department/list`,
        add: `${root}/department/add`,
        update: `${root}/department/update`,
        detail: `${root}/department/detail`,
        delete: `${root}/department/delete`,
        batchDelete: `${root}/department/batchDelete`,
        tree: `${root}/department/tree`
    },
    employee: {
        list: `${root}/employee/list`,
        add: `${root}/employee/add`,
        update: `${root}/employee/update`,
        detail: `${root}/employee/detail`,
        delete: `${root}/employee/delete`,
        batchDelete: `${root}/employee/batchDelete`
    },
    fileCategory: {
        list: `${root}/fileCategory/list`,
        add: `${root}/fileCategory/add`,
        update: `${root}/fileCategory/update`,
        detail: `${root}/fileCategory/detail`,
        delete: `${root}/fileCategory/delete`,
        exportFileCategory: `${root}/fileCategory/exportFileCategory`,
        importFileCategory: `${root}/fileCategory/importFileCategory`,
        batchDelete: `${root}/fileCategory/batchDelete`
    },
    fileServer: {
        list: `${root}/fileServer/list`,
        add: `${root}/fileServer/add`,
        update: `${root}/fileServer/update`,
        detail: `${root}/fileServer/detail`,
        delete: `${root}/fileServer/delete`,
        batchDelete: `${root}/fileServer/batchDelete`
    },
    fileRecord: {
        list: `${root}/fileRecord/list`,
        add: `${root}/fileRecord/add`,
        update: `${root}/fileRecord/update`,
        detail: `${root}/fileRecord/detail`,
        delete: `${root}/fileRecord/delete`,
        batchDelete: `${root}/fileRecord/batchDelete`
    },
    building: {
        list: `${root}/building/list`,
        add: `${root}/building/add`,
        update: `${root}/building/update`,
        detail: `${root}/building/detail`,
        delete: `${root}/building/delete`,
        batchDelete: `${root}/building/batchDelete`
    },
    gate: {
        list: `${root}/gate/list`,
        batchAuthPersonGates: `${root}/gate/batchAuthPersonGates`,
        batchCancelPersonGateAuths: `${root}/gate/batchCancelPersonGateAuths`,
        listPersonGates: `${root}/gate/listPersonGates`,
        updatePersonAuthGates: `${root}/gate/updatePersonAuthGates`,
        add: `${root}/gate/add`,
        update: `${root}/gate/update`,
        detail: `${root}/gate/detail`,
        delete: `${root}/gate/delete`,
        batchConfigRealtimeWatch: `${root}/gate/batchConfigRealtimeWatch`,
        batchCancelRealtimeWatch: `${root}/gate/batchCancelRealtimeWatch`,
        batchDelete: `${root}/gate/batchDelete`,
        batchAddFistCardPerson: `${root}/gate/batchAddFistCardPerson`,
        listFirstCardPersons: `${root}/gate/listFirstCardPersons`,
        deleteFirstCardPerson: `${root}/gate/deleteFirstCardPerson`,
        batchDeleteFirstCardPersons: `${root}/gate/batchDeleteFirstCardPersons`,
        batchAddDeployPerson: `${root}/gate/batchAddDeployPerson`,
        listDeployPersons: `${root}/gate/listDeployPersons`,
        deleteDeployPerson: `${root}/gate/deleteDeployPerson`,
        updateAuthGroupRule: `${root}/gate/updateAuthGroupRule`,
        updateFirstCardSetting: `${root}/gate/updateFirstCardSetting`,
        updateDeploySetting: `${root}/gate/updateDeploySetting`,
        batchDeleteDeployPersons: `${root}/gate/batchDeleteDeployPersons`
    },
    ctrlDevice: {
        list: `${root}/ctrlDevice/list`,
        delete: `${root}/ctrlDevice/delete`,
        add: `${root}/ctrlDevice/add`,
        update: `${root}/ctrlDevice/update`,
        detail: `${root}/ctrlDevice/detail`,
        dispatchSetting: `${root}/ctrlDevice/dispatchSetting`,
        batchDispatchSetting: `${root}/ctrlDevice/batchDispatchSetting`,
        batchDelete: `${root}/ctrlDevice/batchDelete`
    },
    holidayCalendar: {
        list: `${root}/holidayCalendar/list`,
        add: `${root}/holidayCalendar/add`,
        update: `${root}/holidayCalendar/update`,
        detail: `${root}/holidayCalendar/detail`,
        delete: `${root}/holidayCalendar/delete`,
        batchDelete: `${root}/holidayCalendar/batchDelete`
    },
    trafficTimeGroup: {
        list: `${root}/trafficTimeGroup/list`,
        add: `${root}/trafficTimeGroup/add`,
        update: `${root}/trafficTimeGroup/update`,
        detail: `${root}/trafficTimeGroup/detail`,
        delete: `${root}/trafficTimeGroup/delete`,
        batchDelete: `${root}/trafficTimeGroup/batchDelete`
    },
    authGroup: {
        list: `${root}/authGroup/list`,
        add: `${root}/authGroup/add`,
        update: `${root}/authGroup/update`,
        detail: `${root}/authGroup/detail`,
        delete: `${root}/authGroup/delete`,
        batchAddPersons: `${root}/authGroup/batchAddPersons`,
        listGroupPersons: `${root}/authGroup/listGroupPersons`,
        deleteGroupPerson: `${root}/authGroup/deleteGroupPerson`,
        batchDeleteGroupPersons: `${root}/authGroup/batchDeleteGroupPersons`,
        batchDelete: `${root}/authGroup/batchDelete`
    },
    person: {
        list: `${root}/person/list`,
        add: `${root}/person/add`,
        update: `${root}/person/update`,
        detail: `${root}/person/detail`,
        delete: `${root}/person/delete`,
        batchDelete: `${root}/person/batchDelete`
    },
    trafficRecord: {
        list: `${root}/trafficRecord/list`,
        add: `${root}/trafficRecord/add`,
        update: `${root}/trafficRecord/update`,
        detail: `${root}/trafficRecord/detail`,
        delete: `${root}/trafficRecord/delete`,
        batchDelete: `${root}/trafficRecord/batchDelete`
    }, deviceFailureRecord: {
        list: `${root}/deviceFailureRecord/list`,
        add: `${root}/deviceFailureRecord/add`,
        update: `${root}/deviceFailureRecord/update`,
        detail: `${root}/deviceFailureRecord/detail`,
        delete: `${root}/deviceFailureRecord/delete`,
        batchDelete: `${root}/deviceFailureRecord/batchDelete`
    }, deviceWarningRecord: {
        list: `${root}/deviceWarningRecord/list`,
        add: `${root}/deviceWarningRecord/add`,
        update: `${root}/deviceWarningRecord/update`,
        detail: `${root}/deviceWarningRecord/detail`,
        delete: `${root}/deviceWarningRecord/delete`,
        batchDelete: `${root}/deviceWarningRecord/batchDelete`
    }, peripheralModel: {
        list: `${root}/peripheralModel/list`,
        add: `${root}/peripheralModel/add`,
        update: `${root}/peripheralModel/update`,
        detail: `${root}/peripheralModel/detail`,
        delete: `${root}/peripheralModel/delete`,
        batchDelete: `${root}/peripheralModel/batchDelete`
    }, doorCard: {
        changeStatus: `${root}/doorCard/changeStatus`,
        dispatchDoorCardAuth: `${root}/doorCard/dispatchDoorCardAuth`,
        dispatchPersonAllDoorCardAuth: `${root}/doorCard/dispatchPersonAllDoorCardAuth`,
        list: `${root}/doorCard/list`,
        add: `${root}/doorCard/add`,
        update: `${root}/doorCard/update`,
        detail: `${root}/doorCard/detail`,
        delete: `${root}/doorCard/delete`,
        batchDelete: `${root}/doorCard/batchDelete`
    },
    busNumRule: {
        list: `${root}/busNumRule/list`,
        add: `${root}/busNumRule/add`,
        update: `${root}/busNumRule/update`,
        detail: `${root}/busNumRule/detail`,
        delete: `${root}/busNumRule/delete`,
        importBusNumRule: `${root}/busNumRule/importBusNumRule`,
        exportBusNumRule: `${root}/busNumRule/exportBusNumRule`,
        batchDelete: `${root}/busNumRule/batchDelete`
    },

    operationLog: {
        list: `${root}/operationLog/list`,
        add: `${root}/operationLog/add`,
        update: `${root}/operationLog/update`,
        detail: `${root}/operationLog/detail`,
        delete: `${root}/operationLog/delete`,
        batchDelete: `${root}/operationLog/batchDelete`
    },
    app: {
        list: `${root}/app/list`,
        add: `${root}/app/add`,
        update: `${root}/app/update`,
        updateSetting: `${root}/app/updateSetting`,
        detail: `${root}/app/detail`,
        delete: `${root}/app/delete`,
        appInfo: `${root}/app/appInfo`,
        batchDelete: `${root}/app/batchDelete`
    },
    peripheral: {
        list: `${root}/peripheral/list`,
        add: `${root}/peripheral/add`,
        update: `${root}/peripheral/update`,
        detail: `${root}/peripheral/detail`,
        delete: `${root}/peripheral/delete`,
        appInfo: `${root}/peripheral/appInfo`,
        batchDelete: `${root}/peripheral/batchDelete`
    },
    scheduledTask: {
        list: `${root}/scheduledTask/list`,
        add: `${root}/scheduledTask/add`,
        update: `${root}/scheduledTask/update`,
        detail: `${root}/scheduledTask/detail`,
        delete: `${root}/scheduledTask/delete`,
        batchDelete: `${root}/scheduledTask/batchDelete`
    },
    systemNotice: {
        list: `${root}/systemNotice/list`,
        add: `${root}/systemNotice/add`,
        update: `${root}/systemNotice/update`,
        detail: `${root}/systemNotice/detail`,
        delete: `${root}/systemNotice/delete`,
        batchDelete: `${root}/systemNotice/batchDelete`
    }, areaType: {
        list: `${root}/areaType/list`,
        add: `${root}/areaType/add`,
        update: `${root}/areaType/update`,
        detail: `${root}/areaType/detail`,
        delete: `${root}/areaType/delete`,
        batchDelete: `${root}/areaType/batchDelete`
    }, mchAccount: {
        list: `${root}/mchAccount/list`,
        add: `${root}/mchAccount/add`,
        update: `${root}/mchAccount/update`,
        detail: `${root}/mchAccount/detail`,
        delete: `${root}/mchAccount/delete`,
        batchDelete: `${root}/mchAccount/batchDelete`
    },bannerSetting: {
        list: `${root}/bannerSetting/list`,
        add: `${root}/bannerSetting/add`,
        update: `${root}/bannerSetting/update`,
        detail: `${root}/bannerSetting/detail`,
        delete: `${root}/bannerSetting/delete`,
        batchDelete: `${root}/bannerSetting/batchDelete`
    },
    system: {
        generalInfo: `${root}/system/generalInfo`
    },
    centralAuthApplyRecord: {
        list: `${root}/centralAuthApplyRecord/list`,
        detail: `${root}/centralAuthApplyRecord/detail`,
        approve: `${root}/centralAuthApplyRecord/approve`,
    }, deviceMessage: {
        list: `${root}/deviceMessage/list`,
        detail: `${root}/deviceMessage/detail`,
        batchDelete: `${root}/deviceMessage/batchDelete`,
        delete: `${root}/deviceMessage/delete`,
        approve: `${root}/deviceMessage/approve`,
    },
    statisticsReport: {
        statisticsPersonByGender: `${root}/statisticsReport/statisticsPersonByGender`,
        statisticsPersonByAge: `${root}/statisticsReport/statisticsPersonByAge`,
        statisticsPersonByPost: `${root}/statisticsReport/statisticsPersonByPost`,
        statisticsPersonByArea: `${root}/statisticsReport/statisticsPersonByArea`,
        statisticsCtrlDeviceByModel: `${root}/statisticsReport/statisticsCtrlDeviceByModel`,
        statisticsGateByType: `${root}/statisticsReport/statisticsGateByType`,
        statisticsPeripheralByMode: `${root}/statisticsReport/statisticsPeripheralByMode`,
        statisticsBuildingByType: `${root}/statisticsReport/statisticsBuildingByType`,
    },
    mqtt: {
        mqttInfo: `${root}/mqtt/mqttInfo`,
    },

    commonFile: {
        download: `${root}/commonFile/download`
    }
};

export default Object.assign(
    {
        $base: {
            domain: domain,
            port: port,
            root: root,
        },

    },
    api
)
